export default function truncateText(text) {
  return `${text?.substring(0, 6)}...${text?.substring(36, 43)}`;
}
